<div class="gdp-create-update-dictionary-form">
  <form [formGroup]="form">
    <div class="form-group">
      <label for="substitute" translate>internal-facilities.ai-assistant.form.substitute.label</label>
      <div class="vox-input-group vox-input-group_dense"
        [ngClass]="{'vox-input-group_invalid': isFieldValid('substitute')}">
        <input class="vox-text-field" id="substitute" type="text"
        formControlName="substitute" (input)="onEmitFormValues()"
        [placeholder]="'internal-facilities.ai-assistant.form.substitute.placeholder' | translate" />
        <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
        <span class="vox-input-group__error-message"
          translate>internal-facilities.ai-assistant.form.errors.required</span>
      </div>
    </div>
    <div class="form-group">
      <label for="replacement" translate>
        internal-facilities.ai-assistant.form.replacement.label
        <div class="icon-small-info"
        [ngbTooltip]="'internal-facilities.ai-assistant.form.replacement.tooltip' | translate"></div>
      </label>
      <div class="vox-input-group vox-input-group_dense"
      [ngClass]="{'vox-input-group_invalid': isFieldValid('replacement'), 'textarea-invalid': isFieldValid('replacement')}">
        <textarea class="vox-text-field"
        type="text" id="replacement"
        style="height: unset;"
        formControlName="replacement"
        (input)="onEmitFormValues()"
        [placeholder]="'internal-facilities.ai-assistant.form.replacement.placeholder' | translate"></textarea>
        <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
        <span class="vox-input-group__error-message"
          translate>internal-facilities.ai-assistant.form.errors.required</span>
      </div>
    </div>
    <div class="form-group form-group--toggle">
      <vox-toggle class="vox-toggle" [(toggleOn)]="enabled" [config]="toggle"
      (change)="onEmitFormValues()"></vox-toggle>
      <label class="vox-label" translate>internal-facilities.ai-assistant.form.enabled.label</label>
    </div>
  </form>
</div>